import React from "react";
import Panel from "../../components/panels/panel";
import { Message } from "semantic-ui-react";
import { routes } from "utilities/routing/generatedRoutes";
import { PhosphorWarningCircle } from "components/Atoms/PhosphorIcon";
interface Props {
  config: server.dto.DashboardSystemMessagePanelConfig
}

const SystemMessagesPanel = (props: Props) => {
  const displaySubscriptionOkButtonForTypes: server.dto.SystemMessageTypes[] = ["stripePaymentMethodUnknownProblem", "stripePaymentMethodInsufficientFunds", "configurePaymentMethodReminder"];
  const readMoreLinks = [{ type: "configurePaymentMethodReminder", url: `${site.promoSiteUrl}/blog/article/491` }];

  return <>
    {props.config.systemMessages.map((message, idx) => {
      const displaySubscriptionOkButton = displaySubscriptionOkButtonForTypes.includes(message.type);
      const readMoreLink = readMoreLinks.find(x => x.type === message.type)?.url;

      return <Panel
        key={idx}
        panelClassName="s1_dashboard-panel"
      >
        <div className="flex margin-bottom-large gap">
          {message.type !== "unknown" && <div>
            <PhosphorWarningCircle iconColor="error" iconSize="large" />
          </div>}
          <div>
            <h2>
              {message.title}
            </h2>
          </div>
        </div>

        <div className={"margin-bottom-large"}>
          <Message color={"blue"} key={idx}>
            <div dangerouslySetInnerHTML={{ __html: message.content }}></div>
          </Message>
        </div>

        {(displaySubscriptionOkButton || displaySubscriptionOkButton) &&
          <div className="flex justify-end">
            {(readMoreLink) && <div className="margin-right">
              <a href={readMoreLink} className="button-new secondary" rel="noreferrer" target={"_blank"}>{RESX.GeneralLabels.ReadMore}</a>
            </div>}
            {displaySubscriptionOkButton && <div>
              <a href={routes.subscription_Detail().absolute} className="button-new primary">{RESX.Buttons.BtnOk}</a>
            </div>}
          </div>}

      </Panel >;
    })}
  </>;
};

export default SystemMessagesPanel;